module.exports = __webpack_public_path__ + "img/objective3.f11db7f6.jpg";